<div class="modal fade show d-block" id="manageFixtureModal" tabindex="-1" aria-labelledby="manageUserLabel">
  <div class="modal-dialog">
    <div class="modal-content border-0 shadow-lg rounded-3">
<div class="modal-header d-flex justify-content-between">
  <h5 class="modal-title">Please select an option for sending email</h5>
  <button type="button" class="close" (click)="dialogRef.close()" aria-label="Close">
    <span aria-hidden="true"><i class="fa fa-close"></i></span>
  </button>
</div>
<form [formGroup]="emailForm" name="emailForm" (ngSubmit)="SendAnalyticsReportByEmail(emailForm)">
  <div class="modal-body">

    <div class="form-group">
      <label for="emailType">In which environment you want to send the email?</label>
      <select id="emailType" formControlName="emailType" class="form-control" (change)="onEmailTypeChange($event)">
        <option [value]="item.emailType" *ngFor="let item of emailTypeForReport">{{item.key}}</option>
      </select>
      <div class="validation-error" *ngIf="emailFormSubmitted && emailForm.get('emailType')?.errors?.['required']">
        Environment is required
      </div>
    </div>

    <div class="form-group">
      <label for="emailsToNotify">Emails to notify</label>
      <mat-chip-grid #chipList aria-label="Emails list" class="email_notify_input">
        <mat-chip *ngFor="let email of emails" [removable]="true" (removed)="removeEmail(email)">
          {{ email }}
          <span class="custom-remove-icon" matChipRemove>&times;</span>
        </mat-chip>

        <input class="form-control" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addEmail($event)" />
      </mat-chip-grid>

      <div class="validation-error" *ngIf="emailFormSubmitted && emails.length === 0">
        Email is required
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="dialogRef.close()">Close</button>
    <button class="btn btn-primary" type="submit">Ok</button>
  </div>
</form>
</div>
</div>
</div>